// routes/_app.market.submit.step-2.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_app.market.submit.step-2')

export const handle = { name: 'market/submit/step-2', showAppNav: true }

export default dynamic(getClientModule, { ssr: false })
